import React from 'react';
import PropTypes from 'prop-types';
import {CSSTransitionGroup} from 'react-transition-group';
import {inject, observer, PropTypes as MobxPropTypes} from 'mobx-react';
import {browserOnly} from './EnvSplit';
import Alert from './Alert';

@browserOnly
@inject(({store: {notifications: {list}}}) => ({list}))
@observer
class Notifications extends React.Component {
  static propTypes = {
    list: MobxPropTypes.observableArrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      dismiss: PropTypes.func.isRequired,
      type: PropTypes.oneOf(['success', 'error']).isRequired,
      title: PropTypes.string,
      text: PropTypes.string,
    })).isRequired,
  };

  render() {
    const {list, ...rest} = this.props;

    return (
      <CSSTransitionGroup
        {...rest}
        component="div"
        className="notifications"
        transitionName="fade"
        transitionEnterTimeout={200}
        transitionLeaveTimeout={200}
      >
        {list.map(notification => (
          <Alert
            data-qa={`notification-${notification.type}`}
            key={notification.id}
            type={notification.type}
            className="notification"
            onClick={notification.dismiss}
            title={notification.title}
            text={notification.text}
          />
        ))}
      </CSSTransitionGroup>
    );
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./spa/Components/Notifications.jsx